import { css, cx } from '@emotion/css';
import CloseButton from '../common/CloseButton';
import QuestionTitle from '../common/QuestionTitle';
import { QuestionWrapperStyle } from '../steps/stepsStyle';
import MultilineText from '../utils/MultilineText';
import { useStudyContext } from '../utils/StudyContext';
import { useTranslationsContext } from '../utils/TranslationsContext';

const ThankYouMessage = () => {
    const { t } = useTranslationsContext();
    const { study } = useStudyContext();

    return (
        <div>
            <div className={QuestionWrapperStyle}>
                <div className={CenterStyle}>
                    <QuestionTitle
                        label={
                            study.translations?.find(
                                (v) => v.key === 'panelSignupSuccessTitle',
                            )?.value ??
                            t(`confirmationScreen.thanksForResponse`)
                        }
                    />
                    {
                        <MultilineText
                            text={
                                study.translations?.find(
                                    (v) =>
                                        v.key ===
                                        'panelSignupSuccessDescription',
                                )?.value ??
                                t(
                                    `confirmationScreen.thanksForYourResponseDescription`,
                                )
                            }
                        />
                    }
                </div>
            </div>
            <div className={cx(CenterStyle, BottomStyle, FooterStyle)}>
                <CloseButton />
            </div>
        </div>
    );
};

export default ThankYouMessage;

const CenterStyle = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    > * {
        text-align: center;
    }
`;

const BottomStyle = css`
    margin-top: auto;
    align-self: flex-end;
`;

const FooterStyle = css`
    display: flex;
    flex-direction: column;
    gap: 12px;
    &:last-child {
        padding-top: 10px;
    }
`;
